'use strict';

angular.module('PinMeTo.directives').directive('pmtInfinityScroll', function () {
	return {
		restrict: 'A',
		replace: false,
		transclude: false,
		scope: {
			scrollHandler: '&pmtInfinityScroll'
		},
		link: function (scope, elm) {
			let e = angular.element(elm[0]),
				raw = elm[0];
			let handler = function () {
				if (raw.scrollTop + raw.offsetHeight >= raw.scrollHeight - 500) {
					scope.$apply(scope.scrollHandler);
				}
			};
			e.bind('scroll', handler);
			scope.$on('$destroy', function () {
				return e.unbind('scroll', handler);
			});
		}
	};
});
